export const features = {
    notifications: false,
    supervisors: false,
    student: false,
    payment: false
}